import { useAppliedQueryFilters } from 'components/QueryFilters'

import { useFilterSearchParams } from '../../hooks/useFilterSearchParams'
import { useVisitsFilter } from '../../hooks/useVisitsFilter'

export function useAppliedFilters() {
  const { filterValues } = useFilterSearchParams()
  const { filterItems } = useVisitsFilter()

  return useAppliedQueryFilters({
    filterDefinitions: filterItems,
    filterValues,
  })
}
